import styled from "styled-components";
import { Pass2Svg ,PremiumServiceSvg} from "../../components/Assets";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import useAuth from "../../hooks/useAuth";
import CmmApi from "../../apis/cmm.api";

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 20px;
  gap: 24px;
`;

export default function SpecialReviewOnlyForPremium() {
  const { ceoInfo } = useAuth();
  const handleSaleLink = async () =>{
    const res = await CmmApi.getManagerCodeByShopIdx(ceoInfo.shop_idx);
    if(res.data){
      //using set timeout bc window.open not working on safari
      setTimeout(() => {
      window.open(`${process.env.REACT_APP_SALE_ENPOINT}/apply/${res.data}/shop/${ceoInfo.shop_idx}`,'_blank', 'rel=noopener noreferrer')
      })
    }
  }
  return (
    // <Box
    //   style={{
    //     height: "calc(100vh - 200px)",
    //   }}
    // >
    //   <img src={Pass2Svg}></img>
    //   <p className="flex flex-col gap-2">
    //     <b className="text-lg text-center">
    //       프리미엄에서만 이용하실 수 있어요.
    //     </b>
    //     <span className="flex flex-col">
    //       <span className="text-center">
    //         사장님 리뷰를 대신 관리하고 분석해 드려요. 고객과의
    //       </span>
    //       <span className="text-center">
    //         소통은 저희에게 맡기시고 장사에만 집중하세요.
    //       </span>
    //       <span className="text-center text-appblue mt-8 mb-6">
    //         첫 가입 시 한 달 무료체험을 할 수 있어요!
    //       </span>
    //     </span>
    //   </p>
    //   <SolidBlueBtn onClick={()=> {
    //     window.open(`${process.env.REACT_APP_SALE_ENPOINT}`,'_blank', 'rel=noopener noreferrer')}} className={"py-2 px-5"}>
    //     <p>무료 체험 신청하기</p>
    //   </SolidBlueBtn>
    // </Box>
    <div
          style={{
            height: "calc(85vh - 100px)",
          }}
          className="flex flex-col w-screen h-screen items-center text-center justify-center px-[30px] "
        >
          <div className="mb-6">
            <img src={PremiumServiceSvg} />
          </div>
          <div className="font-bold mb-2">
            프리미엄에서만 이용하실 수 있어요.
          </div>
          <div className="mb-7 text-blue">
            사장님 리뷰를 대신 관리하고 분석해 드려요. 고객과의 소통은 저희에게
            맡기시고 장사에만 집중하세요.
          </div>
          <div className="text-[#3451d7]">
            첫 가입 시 한 달 무료체험을 할 수 있어요!
          </div>
          <div className="w-full items-center flex justify-center">
            <SolidBlueBtn
              onClick={handleSaleLink}
              className="mt-6"
              style={{ padding: "8px 20px" }}
            // onClick={() => navigate(ROUTE_PATHS.EditCardManage)}
            >
              무료 체험 신청하기
            </SolidBlueBtn>
          </div>
        </div>
  );
}
